<template>
    <el-form-item label="">
        <div class="el-form-item__content">
            <div class="el-input el-input--medium el-input__wrapper">
                <img class="googlepin" src="../../assets/images/google-maps-location-marker.svg"><input autocomplete="off" class="el-input__inner" v-model="autocomplete" id="autocompleteaddress" name="autocompleteaddress" placeholder="Search for an Address" style="padding-left: 30px;"/>
            </div>
        </div>
    </el-form-item>
</template>

<script>
	export default {
        data() {
            return {
                address: {},
				autocomplete : '',
				autocompletefield : '',
            }
        },
        name: 'AutoCompleteAddress',
        props:["config"],
        methods: {
			initAutocomplete() {
				var field = document.querySelector("#autocompleteaddress");
				// Create the autocomplete object, restricting the search predictions to
				// addresses in the US and Canada.
				this.autocompletefield = new google.maps.places.Autocomplete(field, {
					componentRestrictions: { country: ["us", "ca"] },
					fields: ["address_components", "geometry"],
				});
				field.focus();
				// When the user selects an address from the drop-down, populate the
				// address fields in the form.
				this.autocompletefield.addListener("place_changed", fillInAddress);
			},
            fillInAddress() {
				// Get the place details from the autocomplete object.
				const place = this.autocompletefield.getPlace();
				this.address.AddressLine1 = '';
				this.address.AddressLine2 = '';
				this.address.City = '';
				this.address.StateOrProvinceCodeID = '';
				this.address.PostalCode = '';
                this.address.Country = '';
				if (place.geometry) {
					// Get each component of the address from the place details,
					// and then fill-in the corresponding field on the form.
					// place.address_components are google.maps.GeocoderAddressComponent objects
					// which are documented at http://goo.gle/3l5i5Mr
					for (const component of place.address_components) {
						// @ts-ignore remove once typings fixed
						const componentType = component.types[0];

						switch (componentType) {
							case "street_number": {
								this.address.AddressLine1 = component.long_name;
								break;
							}
							case "route": {
								this.address.AddressLine1 += ' ' + component.short_name;
								break;
							}
							case "postal_code": {
								this.address.PostalCode = component.long_name;
								break;
							}
							case "postal_code_suffix": {
								this.address.PostalCode += '-' + component.long_name;
								break;
							}
							case "locality":
								this.address.City = component.long_name;
								break;
							case "administrative_area_level_1": {
								this.address.StateOrProvinceCodeID = component.short_name;
								break;
							}
							case "country":
								this.address.Country = component.short_name;
								break;
						}
					}
				}
				this.autocomplete = '';
                this.$emit('address', this.address);
			},
        },
        mounted() {
            this.initAutocomplete();
        },
        created() {
            window.fillInAddress = this.fillInAddress;
        },
	}
</script>
<style>
	#app .googlepin {
		position: absolute;
		height: 20px;
		width: 20px;
		left: 10px;
	}
	.pac-container.pac-logo.hdpi {
		z-index: 2500;
	}
</style>